import styled from 'styled-components';
import BackgroundImage from 'assets/svg/bg_login_portal_client_grey.svg';

export const BgLogin = styled.div`
  background-image: url(${BackgroundImage});
  background-size: cover;
  width: 100%;
  padding: 18px 20px;
  min-height: 100vh;
  @media only screen and (max-width: 1440px) {
    padding: 15px;
  }
`;

export const DraggableContainer = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: lightgray 0px 0px 24px 5px;
  border: 2px solid lightgray;
  overflow: auto;
  resize: vertical !important;
`;

export const TopBar = styled.div`
  padding: 12px 5px 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d8d8d8;
  i {
    font-size: 18px;
    cursor: pointer;
  }
  height: 5.3em;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  h5 {
    margin: 3px 12px 0 5px;
  }
`;

export const Content = styled.div`
  padding: 12px 18px;
`;

export const Issue = styled.div`
  margin: 10px 0;
  background: #f2f2f2;
  border-radius: 5px;
  padding: 1.3em 1em;
  color: black;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 960px) {
    flex-wrap: wrap;
  }
`;

export const First = styled.div`
  display: flex;
  align-items: center;
  width: 40%;
  margin-right: 1rem;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: space-between;
    margin-right: 0;
  }
`;

export const UserNameLinks = styled.div`
  margin-right: 2rem;
  width: 50%;
  h6 {
    margin: 0;
  }
`;

export const DeparmentName = styled.div`
  padding: 4px 10px;
  border-radius: 5px;
  font-weight: bold;
  background: black;
  color: white;
`;

export const Second = styled.div`
  margin: 0 1rem;
  padding: 0 1rem;
  margin-right: 2rem;
  width: 40%;
  display: flex;
  align-items: center;
  .subject {
    margin-right: 2rem;
    width: 50%;
    h6 {
      margin: 0;
    }
  }

  @media (max-width: 960px) {
    width: 100%;
    margin: 0;
    margin-top: 0.4rem;
    padding: 0;
    justify-content: space-between;
  }
`;

export const Third = styled.div`
  display: flex;
  justify-content: space-between;
  width: 20%;
  i {
    cursor: pointer;
  }
  p {
    margin: 0;
    margin-right: 10px;
    color: gray;
  }
  @media (max-width: 960px) {
    width: 100%;
    margin-top: 1rem;
  }
`;

export const IssueName = styled.div`
  padding: 4px 14px;
  border-radius: 5px;
  font-weight: bold;
`;
